export { default as BulletinCard } from "./BulletinCard";
